export default __webpack_public_path__ + "static/banner-castle-da7118141edd46c8a9a86a440f5afc11.jpg";